export function slugify(title: string, company: string, id: string) {
  return `${title}-${company}-${id}`
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-") // replace spaces & symbols with -
    .replace(/^-+|-+$/g, ""); // trim - from start & end
}
